import { ComboboxOption } from '@headlessui/react'
import { FolderIcon } from '@heroicons/react/24/outline'
import React from 'react'

interface RecentSearchesProps {
  recentSearches: {
    id: string
    name: string
    type: 'offer' | 'firm'
  }[]
  query: string
}

export const RecentSearches = ({
  recentSearches = [],
  query = '',
}: RecentSearchesProps) => {
  if (query !== '' || recentSearches.length === 0) {
    return null
  }

  return (
    <li className="p-2">
      <h2 className="px-3 mt-4 mb-2 text-xs font-semibold text-gray-500">Recent searches</h2>
      <ul className="text-sm text-gray-700">
        {recentSearches.map((search) => (
          <ComboboxOption
            as="li"
            key={search.id}
            value={search}
            className="flex items-center px-3 py-2 rounded-md cursor-pointer select-none group data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden"
          >
            <FolderIcon
              className="size-6 flex-none text-gray-400 group-data-focus:text-white forced-colors:group-data-focus:text-[Highlight]"
              aria-hidden="true"
            />
            <span className="flex-auto ml-3 truncate">{search.name}</span>
            <span className="hidden flex-none ml-3 text-indigo-100 group-data-focus:inline">
              Jump to...
            </span>
          </ComboboxOption>
        ))}
      </ul>
    </li>
  )
}
